import { Modal, Select, SelectItem } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useEffect } from 'react'
import { DatesProvider, DateValue, YearPickerInput } from '@mantine/dates'
import { useForm, zodResolver } from '@mantine/form'
import api from 'src/utils/Api'
import CustomButtom from '../customButtom'
import { IconArrowBarLeft, IconPrinter } from '@tabler/icons-react'
import {
  MESSAGE_ERROR_SERVIDOR,
  PLEASE_FILL_IN_ALL_REQUIRED_FIELDS,
  TITTLE_NOTICE,
} from 'src/utils/Constants'
import { ErrorNotification } from '../notification/errorNotification'
import { openByteArrayNewTab } from 'src/utils/Files'
import { MesEnum } from 'src/enums/MesEnum'
import { WarningNotification } from '../notification/warningNotification'
import { validationDre } from './validation/schema'

type IProps = {
  route: string
  openModal: boolean
  listMes: SelectItem[]
  closeModal: (value: boolean) => void
}

const ModalRelatorioDre: React.FC<IProps> = ({
  route,
  openModal,
  listMes,
  closeModal,
}) => {
  useEffect(() => {
    if (openModal) {
      open()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal])
  const handleChange = (
    event: string | number | boolean | DateValue | File,
    key: string
  ) => {
    form.setFieldValue(key, event)
  }
  const exit = () => {
    close()
    form.reset()
    closeModal(false)
  }
  const form = useForm<{
    ano?: number | null
    mes?: MesEnum | null
  }>({
    initialValues: {
      ano: null,
      mes: null,
    },
    validate: zodResolver(validationDre()),
  })

  const printContas = async () => {
    await api
      .post(route, form.values, {
        responseType: 'blob',
      })
      .then(r => {
        openByteArrayNewTab(r.data, 'file')
        exit()
      })
      .catch(() => {
        ErrorNotification({ message: MESSAGE_ERROR_SERVIDOR })
      })
  }
  const [opened, { open, close }] = useDisclosure(false)
  return (
    <Modal
      opened={opened}
      onClose={close}
      size={'md'}
      closeOnClickOutside={false}
      closeOnEscape={false}
      withCloseButton={false}
      trapFocus={false}
      centered
      radius={10}
    >
      <form
        onSubmit={form.onSubmit(
          () => printContas(),
          () => {
            WarningNotification({
              title: TITTLE_NOTICE,
              message: PLEASE_FILL_IN_ALL_REQUIRED_FIELDS,
            })
          }
        )}
      >
        <Select
          {...form.getInputProps('mes')}
          size={'xs'}
          clearable
          withinPortal
          searchable
          withAsterisk
          onChange={e => handleChange(e, 'mes')}
          w={{ base: '100%' }}
          label={'Mês'}
          placeholder={'Selecione o mês'}
          data={listMes}
        />
        <DatesProvider
          settings={{
            locale: 'pt-br',
          }}
        >
          <YearPickerInput
            {...form.getInputProps('ano')}
            value={form.values.ano ? new Date(form.values.ano, 0) : null}
            onChange={date =>
              form.setFieldValue('ano', date ? date.getFullYear() : null)
            }
            size="xs"
            maxDate={new Date()}
            label="Ano"
            required
          />
        </DatesProvider>
        <CustomButtom
          customJustify="space-between"
          customButtons={[
            {
              label: 'Voltar',
              color: 'red',
              onClick: () => exit(),
              icon: <IconArrowBarLeft />,
              type: 'button',
            },
            {
              label: 'Baixar',
              icon: <IconPrinter />,
              type: 'submit',
            },
          ]}
        />
      </form>
    </Modal>
  )
}
export default ModalRelatorioDre
